import { AdalService } from 'adal-angular4';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryService } from './../../app/shared/services/repository.service';
import { RiskUser } from './../../app/_interfaces/RiskUser.model';



// The main responsibility of this component is to handle the user's login process.
// This is the starting point for the login process. Any component that needs to authenticate
// a user can simply perform a redirect to this component with a returnUrl query parameter and
// let the component perform the login and return back to the return url.
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public user: RiskUser;
  public userIsSetup: boolean;

  constructor(
    private adalService: AdalService,
    private router: Router,
    private repository: RepositoryService
  ) { }

  async ngOnInit() {
   
    try {
      this.repository.loggedInAzure = true;
    
      this.adalService.login();

      this.repository.loggedInAzure = true;
    }
    catch (e) {
      alert('Error during adal login!')
    }
     // const adalUser =  this.adalService.getUser();
    
  }

  login() {
    this.adalService.login();
  }


}

